import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import { UploadForm } from './components/UploadForm';

export function App() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  return (
    <div className="app">
      <header className="app-header">
        <h1>MEG File Upload</h1>
        <UnauthenticatedTemplate>
          <button onClick={() => instance.loginRedirect(loginRequest)}>Sign in</button>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <div className="user">
            <span>{account?.name ?? account?.username}</span>
            <button onClick={() => instance.logoutRedirect()}>Sign out</button>
          </div>
        </AuthenticatedTemplate>
      </header>

      <main>
        <UnauthenticatedTemplate>
          <section className="hero">
            <p>Sign in with your organization account to upload files to a package.</p>
          </section>
        </UnauthenticatedTemplate>

        <AuthenticatedTemplate>
          <UploadForm />
        </AuthenticatedTemplate>
      </main>

      <footer className="app-footer">
        <small>MEG Upload · POC</small>
      </footer>
    </div>
  );
}
